export {
  getNativeVdpPayload,
  nativeMyCarsPayload,
  nativeStcPayload,
  nativeSrpPayload,
  nativeTermsPayload
} from './getNativePayloads';
